import styled from "styled-components";

export const TitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  align: center;
  margin-bottom: 12px;
`;

export const IntegrationActionLinkWrapper = styled.div`
  display: flex;
  gap: 8px;
`;
